import { useState } from 'react'
import PropTypes from 'prop-types'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { MdInfoOutline } from 'react-icons/md'
import HelpPanel from './HelpPanel'
import styles from './Help.module.scss'

/**
 * Info (i) icon. Opens help in a panel on the right, so the page stays where it is.
 * context: screen key, for example "extensions". Without it the button opens all topics.
 */
const HelpTip = ({ context, label, className }) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <button
        type='button'
        className={`${styles.tipButton} ${className || ''}`}
        onClick={() => setShow(true)}
        aria-label={label || 'Help'}
        title={label || 'Help'}
      >
        <MdInfoOutline />
      </button>
      <Offcanvas show={show} onHide={() => setShow(false)} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Help</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <HelpPanel context={context} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

HelpTip.propTypes = {
  context: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
}

export default HelpTip
